import React from "react";
import { Button } from "@mui/material";

interface AdminInkassoDownloadProps {
  onOpenDialog: () => void;
}

const AdminInkassoDownload: React.FC<AdminInkassoDownloadProps> = ({
  onOpenDialog,
}) => {
  return (
    <Button
      variant="contained"
      sx={{
        width: "50%",
        maxWidth: "150px",
        minWidth: "135px",
        backgroundColor: "var(--green)",
        height: "30px",
        margin: "15px 15px 15px 0",
        color: "white",
        fontWeight: "bold",
        fontSize: "var(--h4)",
        padding: "0",
        "&:hover": {
          backgroundColor: "var(--green)",
          opacity: 0.75,
          transition: "opacity 0.3s",
        },
      }}
      onClick={onOpenDialog}
    >
      Inkasso-Export
    </Button>
  );
};

export default AdminInkassoDownload;
